export function numberWithSpaces(x) {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  } else {
    return null;
  }
}

export function formatPrice(price: number): string {
  const formattedPrice: string = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);

  return formattedPrice.replace(/CHF|’/g, ' ').trim() + '.-';
}
